import { render } from "./IDChip.vue?vue&type=template&id=9cc09950&scoped=true"
import script from "./IDChip.vue?vue&type=script&lang=js"
export * from "./IDChip.vue?vue&type=script&lang=js"

import "./IDChip.vue?vue&type=style&index=0&id=9cc09950&scoped=true&lang=css"
/* custom blocks */
import block0 from "./IDChip.vue?vue&type=custom&index=0&blockType=transition&name=fade"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cc09950"]])

export default __exports__